import React, { useEffect, useRef, useState } from 'react';
import ApexCharts from 'apexcharts';
import TauriSectionModalVisual from '../TauriSectionBaseVisual/TauriSectionModalVisual/TauriSectionModalVisual';
import TauriSectionModalMultiVisual from '../TauriSectionBaseVisual/TauriSectionModalMultiVisual/TauriSectionModalMultiVisual';
import setting from '../../config.json';

const TauriLineVisual = ({ chartConfig, chartData, chartOptions, columnSize, rowSize, palettes, themes, chartPalettes }) => {
    const chartRef = useRef(null);
    const [selectedVisual, setSelectedVisual] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        if (!chartData) return;
        const handleDataPointSelection = (event, chartContext, config) => {
            const selectedSliceIndex = config.dataPointIndex;
            const title = chartConfig.binding.context.point.onClick.selectedValueColumn;
            const selectedDesc = chartData[selectedSliceIndex][chartConfig.binding.data.title];
            const selectedVal = chartData[selectedSliceIndex][title];

            if (chartConfig.binding.context.point.onClick.visual || Array.isArray(chartConfig.binding.context.point.onClick.visuals)) {
                let selectedVisual = null;
                if (chartConfig.binding.context.point.onClick.visuals) {
                    // Handle multiple visuals
                    const selectedSliceVisualIndex = config.dataPointIndex;
                    selectedVisual = chartConfig.binding.context.point.onClick.visuals;
                } else {
                    // Handle single visual
                    selectedVisual = chartConfig.binding.context.point.onClick.visual;
                }

                setSelectedVisual(selectedVisual);
                setSelectedData({ title, selectedDesc, selectedVal });

                const tauriElement = document.querySelector('.tauri-host-container');
                if (tauriElement) {
                    if (event) {
                        const { left, top, right, bottom } = tauriElement.getBoundingClientRect();
                        let posX = event.clientX;
                        let posY = event.clientY;
                        if ((event.clientX + setting.modalMinWidth) > window.innerWidth) {
                            posX = event.clientX - setting.modalMinWidth;
                        }
                        if ((event.clientY + setting.modalMinHeight) > window.innerHeight) {
                            posY = event.clientY - setting.modalMinHeight;
                        }

                        setModalPosition({ x: posX, y: posY });
                    }
                }
            }
        };

        const series = chartConfig.binding.data.series.map((seriesItem, index) => ({
            name: seriesItem?.name,
            data: chartData?.map(item => item[seriesItem?.value] ?? null),
            color: chartPalettes[index]?.ranges?.[0] ?? null,
            percent: seriesItem?.percent ?? false
        }));

        const options = {
            chart: {
                ...chartOptions.chart,
                toolbar: {
                    show: true,
                    tools: {
                        download: true
                    }
                },
                events: {
                    dataPointSelection: handleDataPointSelection,
                }
            },
            markers: {
                strokeWidth: chartOptions.markers.strokeWidth,
                discrete: chartData.flatMap((dataItem, dataIndex) => (
                    chartConfig.binding.data.series.map((item, seriesIndex) => ({
                        seriesIndex: seriesIndex,
                        dataPointIndex: dataIndex,
                        fillColor: chartOptions.markers.discrete.fillColor,
                        strokeColor: dataItem[item?.value] < 0 ? 'red' : chartPalettes[seriesIndex].ranges[0],
                        size: chartOptions.markers.discrete.size,
                    }))
                ))
            },
            tooltip: {
                y: {
                    formatter: (value, { seriesIndex }) => {
                        if (value !== undefined && value !== null) {
                            const seriesItem = series[seriesIndex];
                            const formattedValue = value.toLocaleString(undefined, { maximumFractionDigits: setting.DISPLAYED_DECIMALS });
                            if (seriesItem && seriesItem.percent) {
                                return `${formattedValue}%`;
                            }
                            return formattedValue;
                        } else {
                            return '';
                        }
                    }
                },
                style: {
                    fontFamily: 'Lato-Regular'
                }
            },
            grid: chartOptions.grid,
            xaxis: {
                ...chartOptions.xaxis,
                categories: chartData?.map(item => item[chartConfig?.binding?.data?.title] || ''),
                title: {
                    ...chartOptions.yaxis.title,
                    text: chartConfig.xAxis
                }
            },
            yaxis: {
                ...chartOptions.yaxis,
                title: {
                    ...chartOptions.yaxis.title,
                    text: chartConfig.yAxis
                }
            },
            // colors: series.map(item => item.color),
            colors: chartPalettes.flatMap(palette => palette.ranges),
            stroke: chartOptions.stroke,
            series,
            legend: chartOptions.legend
        };

        const chart = new ApexCharts(chartRef.current, options);

        chart.render();

        return () => {
            chart.destroy();
        };
    }, [chartConfig, chartData]);

    return (
        <div>
            <div className="chart-content">
                <div ref={chartRef} />
            </div>
            {selectedVisual && (
                chartConfig.binding.context.point.onClick.visuals ? (
                    <TauriSectionModalMultiVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                ) : (
                    <TauriSectionModalVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                )
            )}
        </div>
    );
};

export default TauriLineVisual;
